"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castToHistoryLevel = exports.HistoryLevelSchema = exports.HistoryLevel = exports.castToHistoryRecordType = exports.HistoryRecordTypeSchema = exports.HistoryRecordType = void 0;
const core_1 = require("../core");
const cast_1 = require("../utils/cast");
// Prefix is:
// h - history (to distinguish from notifications)
// 1 - version
var HistoryRecordType;
(function (HistoryRecordType) {
    HistoryRecordType["ACCOUNTS_CAMPAIGN_CREATED"] = "h1.accounts.campaign-created";
    HistoryRecordType["ACCOUNTS_CAMPAIGN_UPDATED"] = "h1.accounts.campaign-updated";
    HistoryRecordType["ACCOUNTS_CAMPAIGN_DELETED"] = "h1.accounts.campaign-deleted";
    HistoryRecordType["ACCOUNTS_TEAM_CREATED"] = "h1.accounts.team-created";
    HistoryRecordType["ACCOUNTS_TEAM_UPDATED"] = "h1.accounts.team-updated";
    HistoryRecordType["ACCOUNTS_TEAM_DELETED"] = "h1.accounts.team-deleted";
    HistoryRecordType["ACCOUNTS_TEAM_METADATA_UPDATED"] = "h1.accounts.team-metadata-updated";
    HistoryRecordType["ACCOUNTS_TEAM_API_KEY_CREATED"] = "h1.accounts.team-api-key-created";
    HistoryRecordType["ACCOUNTS_TEAM_API_KEY_UPDATED"] = "h1.accounts.team-api-key-updated";
    HistoryRecordType["ACCOUNTS_TEAM_API_KEY_RENEWED"] = "h1.accounts.team-api-key-renewed";
    HistoryRecordType["ACCOUNTS_TEAM_API_KEY_DELETED"] = "h1.accounts.team-api-key-deleted";
    HistoryRecordType["ACCOUNTS_TEAM_TIER_UPDATED"] = "h1.accounts.team-tier-changed";
    HistoryRecordType["ACCOUNTS_TIER_CREATED"] = "h1.accounts.tier-created";
    HistoryRecordType["ACCOUNTS_TIER_UPDATED"] = "h1.accounts.tier-updated";
    HistoryRecordType["ACCOUNTS_TIER_DELETED"] = "h1.accounts.tier-deleted";
    HistoryRecordType["ACCOUNTS_MEMBER_CREATED"] = "h1.accounts.member-created";
    HistoryRecordType["ACCOUNTS_MEMBER_UPDATED"] = "h1.accounts.member-updated";
    HistoryRecordType["ACCOUNTS_MEMBER_DELETED"] = "h1.accounts.member-deleted";
    HistoryRecordType["ACCOUNTS_USER_INVITED"] = "h1.accounts.user-invited";
    HistoryRecordType["ACCOUNTS_USER_REGISTERED"] = "h1.accounts.user-registered";
    HistoryRecordType["ACCOUNTS_USER_UPDATED"] = "h1.accounts.user-updated";
    HistoryRecordType["ACCOUNTS_USER_DELETED"] = "h1.accounts.user-deleted";
    HistoryRecordType["ACCOUNTS_USER_METADATA_UPDATED"] = "h1.accounts.user-metadata-updated";
    HistoryRecordType["ACCOUNTS_INVITATION_CREATED"] = "h1.accounts.invitation-created";
    HistoryRecordType["ACCOUNTS_INVITATION_UPDATED"] = "h1.accounts.invitation-updated";
    HistoryRecordType["ACCOUNTS_INVITATION_DELETED"] = "h1.accounts.invitation-deleted";
    HistoryRecordType["ACCOUNTS_INVITATION_ANSWERED"] = "h1.accounts.invitation-answered";
    HistoryRecordType["ACCOUNTS_TEAM_NOTIFICATION_SETTINGS_UPDATED"] = "h1.accounts.team-notification-settings-updated";
    HistoryRecordType["ACCOUNTS_USER_NOTIFICATION_SETTINGS_UPDATED"] = "h1.accounts.user-notification-settings-updated";
    HistoryRecordType["APPLE_CHANNELS_ASR_CHANNEL_CREATED"] = "h1.apple-channels.asr-channel-created";
    HistoryRecordType["APPLE_CHANNELS_ASR_CHANNEL_UPDATED"] = "h1.apple-channels.asr-channel-updated";
    HistoryRecordType["APPLE_CHANNELS_ASR_CHANNEL_DELETED"] = "h1.apple-channels.asr-channel-deleted";
    HistoryRecordType["APPLE_CHANNELS_ASR_KEYWORD_CREATED"] = "h1.apple-channels.asr-keyword-created";
    HistoryRecordType["APPLE_CHANNELS_ASR_KEYWORD_DELETED"] = "h1.apple-channels.asr-keyword-deleted";
    HistoryRecordType["APPLE_CHANNELS_ASR_KEYWORD_UPDATED"] = "h1.apple-channels.asr-keyword-updated";
    HistoryRecordType["APPLE_CHANNELS_ASR_REGION_CREATED"] = "h1.apple-channels.asr-region-created";
    HistoryRecordType["APPLE_CHANNELS_ASR_REGION_UPDATED"] = "h1.apple-channels.asr-region-updated";
    HistoryRecordType["APPLE_CHANNELS_ASR_REGION_DELETED"] = "h1.apple-channels.asr-region-deleted";
    HistoryRecordType["APPLE_CHANNELS_AST_CHANNEL_CREATED"] = "h1.apple-channels.ast-channel-created";
    HistoryRecordType["APPLE_CHANNELS_AST_CHANNEL_UPDATED"] = "h1.apple-channels.ast-channel-updated";
    HistoryRecordType["APPLE_CHANNELS_AST_CHANNEL_DELETED"] = "h1.apple-channels.ast-channel-deleted";
    HistoryRecordType["APPLE_CHANNELS_AST_REGION_CREATED"] = "h1.apple-channels.ast-region-created";
    HistoryRecordType["APPLE_CHANNELS_AST_REGION_UPDATED"] = "h1.apple-channels.ast-region-updated";
    HistoryRecordType["APPLE_CHANNELS_AST_REGION_DELETED"] = "h1.apple-channels.ast-region-deleted";
    HistoryRecordType["APPLE_CHANNELS_ATT_CHANNEL_CREATED"] = "h1.apple-channels.att-channel-created";
    HistoryRecordType["APPLE_CHANNELS_ATT_CHANNEL_UPDATED"] = "h1.apple-channels.att-channel-updated";
    HistoryRecordType["APPLE_CHANNELS_ATT_CHANNEL_DELETED"] = "h1.apple-channels.att-channel-deleted";
    HistoryRecordType["APPLE_CHANNELS_ATT_REGION_CREATED"] = "h1.apple-channels.att-region-created";
    HistoryRecordType["APPLE_CHANNELS_ATT_REGION_UPDATED"] = "h1.apple-channels.att-region-updated";
    HistoryRecordType["APPLE_CHANNELS_ATT_REGION_DELETED"] = "h1.apple-channels.att-region-deleted";
    HistoryRecordType["APPLE_CHANNELS_PPB_CHANNEL_CREATED"] = "h1.apple-channels.ppb-channel-created";
    HistoryRecordType["APPLE_CHANNELS_PPB_CHANNEL_UPDATED"] = "h1.apple-channels.ppb-channel-updated";
    HistoryRecordType["APPLE_CHANNELS_PPB_CHANNEL_DELETED"] = "h1.apple-channels.ppb-channel-deleted";
    HistoryRecordType["APPLE_CHANNELS_PPB_REGION_CREATED"] = "h1.apple-channels.ppb-region-created";
    HistoryRecordType["APPLE_CHANNELS_PPB_REGION_UPDATED"] = "h1.apple-channels.ppb-region-updated";
    HistoryRecordType["APPLE_CHANNELS_PPB_REGION_DELETED"] = "h1.apple-channels.ppb-region-deleted";
    HistoryRecordType["BUDGETS_BUDGET_PLAN_CREATED"] = "h1.budgets.budget-plan-created";
    HistoryRecordType["BUDGETS_BUDGET_PLAN_UPDATED"] = "h1.budgets.budget-plan-updated";
    HistoryRecordType["BUDGETS_BUDGET_PLAN_DELETED"] = "h1.budgets.budget-plan-deleted";
    HistoryRecordType["BUDGETS_BUDGET_ALLOCATED"] = "h1.budgets.budget-allocated";
    HistoryRecordType["BUDGETS_ORDER_DELETED"] = "h1.budgets.order-deleted";
    HistoryRecordType["BUDGETS_BUDGET_PLAN_STARTED"] = "h1.budgets.budget-plan-started";
    HistoryRecordType["BUDGETS_BUDGET_PLAN_ENDED"] = "h1.budgets.budget-plan-ended";
    HistoryRecordType["BUDGETS_BUDGET_PLAN_EXHAUSTED"] = "h1.budgets.budget-plan-exhausted";
    HistoryRecordType["BUDGETS_FUND_EXHAUSTED"] = "h1.budgets.fund-exhausted";
    HistoryRecordType["ATTRIBUTIONS_EVENT_RECEIVED"] = "h1.attributions.event-received";
    HistoryRecordType["ATTRIBUTIONS_SECRET_KEY_CREATED"] = "h1.attributions.secret-key-created";
})(HistoryRecordType = exports.HistoryRecordType || (exports.HistoryRecordType = {}));
exports.HistoryRecordTypeSchema = (0, core_1.StringUnion)([
    HistoryRecordType.ACCOUNTS_CAMPAIGN_CREATED,
    HistoryRecordType.ACCOUNTS_CAMPAIGN_UPDATED,
    HistoryRecordType.ACCOUNTS_CAMPAIGN_DELETED,
    HistoryRecordType.ACCOUNTS_TEAM_CREATED,
    HistoryRecordType.ACCOUNTS_TEAM_UPDATED,
    HistoryRecordType.ACCOUNTS_TEAM_DELETED,
    HistoryRecordType.ACCOUNTS_TEAM_METADATA_UPDATED,
    HistoryRecordType.ACCOUNTS_TEAM_API_KEY_CREATED,
    HistoryRecordType.ACCOUNTS_TEAM_API_KEY_RENEWED,
    HistoryRecordType.ACCOUNTS_TEAM_API_KEY_UPDATED,
    HistoryRecordType.ACCOUNTS_TEAM_API_KEY_DELETED,
    HistoryRecordType.ACCOUNTS_TEAM_TIER_UPDATED,
    HistoryRecordType.ACCOUNTS_TIER_CREATED,
    HistoryRecordType.ACCOUNTS_TIER_UPDATED,
    HistoryRecordType.ACCOUNTS_TIER_DELETED,
    HistoryRecordType.ACCOUNTS_MEMBER_CREATED,
    HistoryRecordType.ACCOUNTS_MEMBER_UPDATED,
    HistoryRecordType.ACCOUNTS_MEMBER_DELETED,
    HistoryRecordType.ACCOUNTS_USER_INVITED,
    HistoryRecordType.ACCOUNTS_USER_REGISTERED,
    HistoryRecordType.ACCOUNTS_USER_UPDATED,
    HistoryRecordType.ACCOUNTS_USER_DELETED,
    HistoryRecordType.ACCOUNTS_USER_METADATA_UPDATED,
    HistoryRecordType.ACCOUNTS_INVITATION_CREATED,
    HistoryRecordType.ACCOUNTS_INVITATION_UPDATED,
    HistoryRecordType.ACCOUNTS_INVITATION_DELETED,
    HistoryRecordType.ACCOUNTS_INVITATION_ANSWERED,
    HistoryRecordType.ACCOUNTS_TEAM_NOTIFICATION_SETTINGS_UPDATED,
    HistoryRecordType.ACCOUNTS_USER_NOTIFICATION_SETTINGS_UPDATED,
    HistoryRecordType.APPLE_CHANNELS_ASR_CHANNEL_CREATED,
    HistoryRecordType.APPLE_CHANNELS_ASR_CHANNEL_UPDATED,
    HistoryRecordType.APPLE_CHANNELS_ASR_CHANNEL_DELETED,
    HistoryRecordType.APPLE_CHANNELS_ASR_KEYWORD_CREATED,
    HistoryRecordType.APPLE_CHANNELS_ASR_KEYWORD_DELETED,
    HistoryRecordType.APPLE_CHANNELS_ASR_KEYWORD_UPDATED,
    HistoryRecordType.APPLE_CHANNELS_ASR_REGION_CREATED,
    HistoryRecordType.APPLE_CHANNELS_ASR_REGION_UPDATED,
    HistoryRecordType.APPLE_CHANNELS_ASR_REGION_DELETED,
    HistoryRecordType.APPLE_CHANNELS_AST_CHANNEL_CREATED,
    HistoryRecordType.APPLE_CHANNELS_AST_CHANNEL_UPDATED,
    HistoryRecordType.APPLE_CHANNELS_AST_CHANNEL_DELETED,
    HistoryRecordType.APPLE_CHANNELS_AST_REGION_CREATED,
    HistoryRecordType.APPLE_CHANNELS_AST_REGION_UPDATED,
    HistoryRecordType.APPLE_CHANNELS_AST_REGION_DELETED,
    HistoryRecordType.APPLE_CHANNELS_ATT_CHANNEL_CREATED,
    HistoryRecordType.APPLE_CHANNELS_ATT_CHANNEL_UPDATED,
    HistoryRecordType.APPLE_CHANNELS_ATT_CHANNEL_DELETED,
    HistoryRecordType.APPLE_CHANNELS_ATT_REGION_CREATED,
    HistoryRecordType.APPLE_CHANNELS_ATT_REGION_UPDATED,
    HistoryRecordType.APPLE_CHANNELS_ATT_REGION_DELETED,
    HistoryRecordType.APPLE_CHANNELS_PPB_CHANNEL_CREATED,
    HistoryRecordType.APPLE_CHANNELS_PPB_CHANNEL_UPDATED,
    HistoryRecordType.APPLE_CHANNELS_PPB_CHANNEL_DELETED,
    HistoryRecordType.APPLE_CHANNELS_PPB_REGION_CREATED,
    HistoryRecordType.APPLE_CHANNELS_PPB_REGION_UPDATED,
    HistoryRecordType.APPLE_CHANNELS_PPB_REGION_DELETED,
    HistoryRecordType.BUDGETS_BUDGET_PLAN_CREATED,
    HistoryRecordType.BUDGETS_BUDGET_PLAN_UPDATED,
    HistoryRecordType.BUDGETS_BUDGET_PLAN_DELETED,
    HistoryRecordType.BUDGETS_BUDGET_ALLOCATED,
    HistoryRecordType.BUDGETS_ORDER_DELETED,
    HistoryRecordType.BUDGETS_BUDGET_PLAN_STARTED,
    HistoryRecordType.BUDGETS_BUDGET_PLAN_ENDED,
    HistoryRecordType.BUDGETS_BUDGET_PLAN_EXHAUSTED,
    HistoryRecordType.BUDGETS_FUND_EXHAUSTED,
    HistoryRecordType.ATTRIBUTIONS_EVENT_RECEIVED,
    HistoryRecordType.ATTRIBUTIONS_SECRET_KEY_CREATED,
], {
    title: "History record type",
    description: "Type of history record",
});
exports.castToHistoryRecordType = (0, cast_1.castToEnum)(HistoryRecordType);
var HistoryLevel;
(function (HistoryLevel) {
    HistoryLevel["INFO"] = "INFO";
    HistoryLevel["WARNING"] = "WARNING";
    HistoryLevel["ERROR"] = "ERROR";
})(HistoryLevel = exports.HistoryLevel || (exports.HistoryLevel = {}));
exports.HistoryLevelSchema = (0, core_1.StringUnion)([HistoryLevel.INFO, HistoryLevel.WARNING, HistoryLevel.ERROR], {
    title: "History level",
    description: "Level of history record",
});
exports.castToHistoryLevel = (0, cast_1.castToEnum)(HistoryLevel);
